
import fetchData from '../utils/fetchData';


const addUserToFirestoreIfNotExists = async (uid, email, providerData) => {
    try {
        const apiUrl = `${process.env.REACT_APP_API_BASE_URL}ai/writer/v1/user/firebase`;

        let providerIds = [];

        // Case 1: providerData is an array (e.g. from Firebase providerData list)
        if (Array.isArray(providerData)) {
            providerIds = providerData.map(p => p.providerId);
        }
        // Case 2: providerData is a string (already a providerId)
        else if (typeof providerData === "string") {
            providerIds = [providerData];
        }
        // Case 3: providerData is null/undefined
        else {
            providerIds = [];
        }


        const response = await fetchData({
            url: apiUrl,
            method: 'POST',
            body: { firebaseUid: uid, email: email, credentialProvider: providerIds }
        });
        
        return response;
    } catch (error) {
        console.error('Error adding user to Firestore:', error);
        throw error;
    }
};

export default addUserToFirestoreIfNotExists;